import { render, staticRenderFns } from "./EditUserAllowedCoreFiles.vue?vue&type=template&id=475b10c2&scoped=true&"
import script from "./EditUserAllowedCoreFiles.vue?vue&type=script&lang=ts&"
export * from "./EditUserAllowedCoreFiles.vue?vue&type=script&lang=ts&"
import style0 from "./EditUserAllowedCoreFiles.vue?vue&type=style&index=0&id=475b10c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475b10c2",
  null
  
)

export default component.exports